// TagToggle theme
//
// Brand-only, two hierarchies (subtle / solid), three sizes.
// Figma file: VPUW5N9Dng7UTK3YX5RJlY, node 130:858 (✅ Tag Toggle).
//
// Default (unselected): white bg, brand subtle-inverse text.
// Selected (active):    subtle → brand subtle bg; solid → brand solid bg.

const baseStyle = {}

const defaultProps = {
  size: 'md',
  variant: 'solid',
  fontWeight: 'medium',
}

const parts = ['container', 'icon']

const sizes = {
  xs: {
    container: { fontSize: 'sm', h: 20, paddingX: 4, paddingY: 2, gapX: 4, borderRadius: 6 },
    icon: { size: 'xs' },
  },
  sm: {
    container: { fontSize: 'sm', h: 24, paddingX: 6, paddingY: 4, gapX: 6, borderRadius: 6 },
    icon: { size: 'xs' },
  },
  md: {
    container: { fontSize: 'sm', h: 32, paddingX: 8, paddingY: 6, gapX: 8, borderRadius: 6 },
    icon: { size: 'sm' },
  },
}

// Each hierarchy has two visual states: unselected and selected.
const variants = {
  // --- subtle -----------------------------------------------------------
  subtle: {
    container: {
      bg: 'white',
      color: 'var(--vui-action-brand-subtle-inverse)',
      bgHover: 'var(--vui-action-brand-subtle-hover)',
      bgPressed: 'var(--vui-action-brand-subtle)',
    },
  },
  subtleSelected: {
    container: {
      bg: 'var(--vui-action-brand-subtle)',
      color: 'var(--vui-action-brand-subtle-inverse)',
      bgHover: 'var(--vui-action-brand-subtle-hover)',
      bgPressed: 'var(--vui-action-brand-subtle-pressed)',
    },
  },

  // --- solid ------------------------------------------------------------
  solid: {
    container: {
      bg: 'var(--vui-action-brand-subtle)',
      color: 'var(--vui-action-brand-subtle-inverse)',
      bgHover: 'var(--vui-action-brand-subtle-hover)',
      bgPressed: 'var(--vui-action-brand-subtle-pressed)',
    },
  },
  solidSelected: {
    container: {
      bg: 'var(--vui-action-brand-solid)',
      color: 'var(--vui-action-brand-solid-inverse)',
      bgHover: 'var(--vui-action-brand-solid-hover)',
      bgPressed: 'var(--vui-action-brand-solid-pressed)',
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
